import React from 'react';
import { useNavigate } from 'react-router-dom';

export const SupportPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        color: 'white'
      }}
    >
      <div
        style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '40px',
          borderRadius: '20px',
          backdropFilter: 'blur(20px)',
          maxWidth: '800px',
          width: '100%',
          textAlign: 'center'
        }}
      >
        <button
          onClick={() => navigate('/')}
          style={{
            alignSelf: 'flex-start',
            marginBottom: '20px',
            color: 'white',
            textDecoration: 'none',
            fontWeight: 600,
            background: 'rgba(255,255,255,0.2)',
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Home
        </button>

        <h1 style={{ fontSize: '40px', fontWeight: 700, marginBottom: '20px' }}>Support</h1>
        <p style={{ marginTop: '20px', fontSize: '18px', opacity: 0.9 }}>
          Have a question or a complaint? We're here to help.
        </p>
        <p style={{ marginTop: '10px' }}>Please send an email to:</p>
        <a
          href="mailto:support@thecontactgame.com"
          style={{
            fontSize: '24px',
            fontWeight: 700,
            color: 'white',
            textDecoration: 'none',
            display: 'block',
            marginTop: '10px'
          }}
        >
          support@thecontactgame.com
        </a>
      </div>
    </div>
  );
};
